import { Padding } from '../../../interfaces/Charts';

export const CHART_HEIGHT = 160;
export const VM_CHART_HEIGHT = 320;
export const SVG_TOP_BOTTOM_PADDING = 10;
export const SVG_LEFT_RIGHT_PADDING = 4;
export const PEAK_CIRCLE_RADIUS = 5;
export const PEAK_CIRCLE_STROKEWIDTH = 2;
export const MAX_VALUE_AXIS_WIDTH = 40;
export const DEFAULT_PADDING: Padding = {
  top: SVG_TOP_BOTTOM_PADDING + PEAK_CIRCLE_RADIUS + PEAK_CIRCLE_STROKEWIDTH / 2,
  bottom: SVG_TOP_BOTTOM_PADDING,
  right: SVG_LEFT_RIGHT_PADDING,
  left: SVG_LEFT_RIGHT_PADDING,
};
export const GAUGE_CHART_RECT_HEIGHT = 25;
export const GAUGE_CHART_VERTICAL_PADDING = 14;
export const GAUGE_CHART_RECT_PADDING = 35;
export const BAR_GAP = 9;
